import { useState } from "react";
import { UserPlus } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export const InvitePrescripteurDialog = ({ demande, onDone }) => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ nom: demande.prescripteur || "", email: demande.prescripteur_courriel || "" });
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/demandes/${demande.id}/prescripteur/inviter`, f);
      toast.success(data.cree ? (data.invitation_envoyee ? `Compte créé et invitation envoyée à ${f.email}` : "Compte créé — l'invitation n'a pas pu être envoyée")
        : `Dossier relié au compte existant de ${data.prescripteur}`);
      setOpen(false);
      onDone();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <>
      <Button variant="outline" size="sm" className="mt-2" onClick={() => setOpen(true)} data-testid="invite-prescripteur-button">
        <UserPlus className="h-4 w-4 mr-1" /> Créer le compte du médecin prescripteur
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="invite-prescripteur-dialog">
          <DialogHeader><DialogTitle>Créer le compte du médecin prescripteur</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-500">Le médecin reçoit un courriel pour choisir son mot de passe (lien valable 72 h). Il ne verra que les dossiers reliés à son compte, sans nom ni RAMQ du patient.</p>
          <div className="space-y-3">
            <div><Label>Nom du médecin</Label><Input value={f.nom} onChange={(e) => setF({ ...f, nom: e.target.value })} data-testid="invite-prescripteur-nom" /></div>
            <div><Label>Courriel</Label><Input type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="invite-prescripteur-email" /></div>
          </div>
          <DialogFooter>
            <Button onClick={submit} disabled={busy || !f.nom.trim() || !f.email.trim()} style={{ background: "#0284C7" }} data-testid="invite-prescripteur-submit">Créer et envoyer l'invitation</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
